import React from 'react';
import { ExternalLink, CreditCard } from 'lucide-react';

const AdBanner = () => {
  return (
    <div 
      className="rounded-lg shadow-md p-6 border border-blue-100 relative overflow-hidden group mb-12"
    >
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 z-0 transition-transform duration-500 group-hover:scale-105"
        style={{
          backgroundImage: 'url(/ad-bg.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-transparent z-0" />

      {/* Content */}
      <div className="relative z-10 text-white flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex-1 text-center md:text-left">
          <div className="flex items-center justify-center md:justify-start space-x-2 mb-2">
            <CreditCard className="h-6 w-6 text-blue-400" />
            <h3 className="text-xl font-bold">Smart Wallet Picks</h3>
            <span className="text-xs bg-white/20 px-2 py-0.5 rounded text-gray-200">Sponsored</span>
          </div>
          
          <p className="text-gray-100 text-sm md:text-base leading-relaxed max-w-2xl">
            Maximize your credit card rewards! Find the best cards for your lifestyle and start earning more today.
          </p>
        </div>

        <a
          href="https://smartwalletpicks.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-blue-600/90 hover:bg-blue-600 backdrop-blur-sm text-white font-bold py-3 px-8 rounded-lg transform transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg flex items-center space-x-2 border border-blue-400/30 whitespace-nowrap"
        >
          <span>Explore Cards</span>
          <ExternalLink className="h-4 w-4" />
        </a>
      </div>
    </div>
  );
};

export default AdBanner;
